import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import KanjiHeroSection from './components/KanjiHeroSection';
import SoundPhilosophySection from './components/SoundPhilosophySection';
import AboutSection from './components/AboutSection';
import StudioSection from './components/StudioSection';
import StudioBuildSection from './components/StudioBuildSection';
import ServicesSection from './components/ServicesSection';
import WorksSection from './components/WorksSection';
import SoundGallerySection from './components/SoundGallerySection';
import ContactSection from './components/ContactSection';
import { SITE_URL, useSeo } from '../../lib/seo';

export default function Home() {
  useSeo({
    title: '合同会社WakuWaku | 大阪・箕面市 映像音響MA制作',
    description:
      '合同会社WakuWakuは大阪・箕面市の映像音響MA制作チームです。企業VP・CM音響制作、映画・映像作品のMA・効果音制作、ライブ配信音声まで幅広く対応。音で世界をワクワクさせるクリエイティブスタジオ。',
    path: '/',
    keywords:
      'MA制作,映像音響,音響制作,整音,ナレーション,効果音,大阪,箕面市,企業VP,CM音声,録音スタジオ,合同会社WakuWaku',
  });

  useEffect(() => {
    const siteUrl = SITE_URL;
    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': `${siteUrl}/#organization`,
          name: '合同会社WakuWaku',
          url: `${siteUrl}/`,
          logo: {
            '@type': 'ImageObject',
            url: `${siteUrl}/images/logo.png`,
          },
          address: {
            '@type': 'PostalAddress',
            addressLocality: '箕面市',
            addressRegion: '大阪府',
            addressCountry: 'JP',
          },
          description: '大阪・箕面市から映像・空間・人の心を音でつなぐクリエイティブチーム。企業VP・CM音響制作、映画・映像作品のMA・効果音制作を手がけています。',
        },
        {
          '@type': 'LocalBusiness',
          '@id': `${siteUrl}/#localbusiness`,
          name: '合同会社WakuWaku',
          url: `${siteUrl}/`,
          image: `${siteUrl}/og-image.jpg`,
          address: {
            '@type': 'PostalAddress',
            addressLocality: '箕面市',
            addressRegion: '大阪府',
            addressCountry: 'JP',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 34.8275,
            longitude: 135.4706,
          },
          priceRange: 'お見積もり',
          description: '大阪・箕面市から映像・空間・人の心を音でつなぐクリエイティブチーム。企業VP・CM音響制作、映画・映像作品のMA・効果音制作を手がけています。',
          sameAs: [],
        },
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: `${siteUrl}/`,
          name: '合同会社WakuWaku',
          publisher: { '@id': `${siteUrl}/#organization` },
          inLanguage: 'ja',
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: `${siteUrl}/`,
          name: '合同会社WakuWaku | 大阪・箕面市 映像音響MA制作',
          description: '合同会社WakuWakuは大阪・箕面市の映像音響MA制作チームです。企業VP・CM音響制作、映画・映像作品のMA・効果音制作、ライブ配信音声まで幅広く対応。',
          isPartOf: { '@id': `${siteUrl}/#website` },
          inLanguage: 'ja',
          dateModified: '2026-03-24',
        },
      ],
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('schema-home');
      if (el) document.head.removeChild(el);
    };
  }, []);

  return (
    <div className="min-h-screen bg-site-dark text-white">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <KanjiHeroSection />
      <HeroSection />
      <SoundPhilosophySection />
      <AboutSection />
      <StudioSection />
      <StudioBuildSection />
      <ServicesSection />
      <WorksSection />
      <SoundGallerySection />
      <ContactSection />
      <Footer />
    </div>
  );
}
